import React from 'react'
import { EmtButton, EmtButtonProps, EmtIcon } from 'emt-components-v2'
import { useTranslation } from 'next-i18next'

interface Props extends EmtButtonProps {
  isFavorite: boolean
}

const FavoriteButton: React.FC<Props> = ({ isFavorite, ...props }) => {
  const { t } = useTranslation('profile')

  return (
    <EmtButton
      fullWidth
      size="large"
      variant="whiteOutlined"
      startIcon={<EmtIcon className={isFavorite ? 'emt-heart' : 'emt-heart-1'} sx={{ fontWeight: 'bold' }} />}
      {...props}
    >
      {t('profileSidebar.heart')}
    </EmtButton>
  )
}

export default FavoriteButton
